export enum IndividualType {
    Parent = "Parent",
    Guardian = "Guardian",
    Student = "Student"
}